import Icon from '../components/Icon.vue'

Icon.register({
  wifi: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M634.9 154.9c6.7 6.2 6.8 16.6 0.4 23l-34.2 34c-6.1 6.1-16 6.2-22.4 0.4-145.9-133.7-371.3-133.7-517.3 0-6.4 5.8-16.3 5.7-22.4-0.4l-34.2-34c-6.4-6.4-6.3-16.8 0.3-23 177.1-163.8 452.6-163.9 629.8 0zM320 352c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM522.7 268.4c6.9 6.1 7.1 16.7 0.6 23.1l-34.4 34c-6 5.9-15.7 6.3-22 0.8-83.8-72.4-209.5-72.6-293.5 0-6.4 5.5-16 5.1-22-0.8l-34.4-34c-6.5-6.5-6.3-17 0.6-23.1 115.1-101.8 290.1-101.9 405.3 0z'
      }
    ]
  }
})
